import React from 'react';
import { FormControl, Select, InputBase, MenuItem, Typography } from '@mui/material';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
import styles from './index.module.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const ClientContactsDropdown = ({ handleSelect, selectedValue, options,name }) => {
    console.log(options)
    const menuProps = {
        PaperProps: {
            className: styles.menuPaper,
        },
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }
    }
    console.log(selectedValue)
    return (
        <>
            <Typography sx={{
                fontSize: '0.9rem',
                color: '#555',
                marginBottom: '0'
            }} variant="subtitle1" gutterBottom>
                Client Contact
            </Typography>
            <Select
                className={styles.dropdown}
                value={selectedValue}
                onChange={(event) => handleSelect(event, name)}
                displayEmpty
                MenuProps={menuProps}
                renderValue={(value) => {
                    const selectedContact = options.find(option => option.id === value);
                    return selectedContact ? selectedContact.name : 'Select Client Contact';
                }}
                IconComponent={KeyboardArrowDownIcon} // Custom arrow icon

            >
                <MenuItem disabled className={styles.option} value={'Select Client Contact'}>
                    Select Client Contact
                </MenuItem>
                {options?.map((option, index) => (
                    <MenuItem key={index} className={styles.option} value={option?.id}>
                        {option?.name}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
};

export default ClientContactsDropdown;
